var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "search-item clearfix",
      attrs: { "data-item-id": _vm.item.id },
    },
    [
      _c("div", { staticClass: "item-content" }, [
        _c("div", { staticClass: "list-item-article-title" }, [
          _c("a", {
            staticClass: "search-item-link",
            attrs: { href: _vm.item_href },
            domProps: { innerHTML: _vm._s(_vm.item.title) },
          }),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "list-item-article-body",
          domProps: { innerHTML: _vm._s(_vm.item.text) },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "list-item-article-date" }, [
          _vm._v(_vm._s(_vm.item.journal_number)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }